import { styled } from '@mui/system';
import { Typography, Box } from '@mui/material';
import { TextInputExtended } from '@cw-ui/form-components';

export const UploadInput = styled('div')(() => ({
    width: '100%',
    display: 'flex',
}));

export const Subtext = styled(Typography)(({ theme }) => ({
    width: '100%',
    color: theme.palette.text.secondary,
    fontSize: '14px',
    fontWeight: 400,
}));

export const SplitContainer = styled(Box)(() => ({
    padding: '0px 16px',
}));

export const UploadedFileInput = styled(TextInputExtended)(() => ({
    width: '463px',
}));

export const UploadButtonContainer = styled(Box)(() => ({
    width: '132px',
    paddingTop: '10px',
}));
export const UploadRow = styled('div')(() => ({
    display: 'flex',
    paddingTop: '16px',
    flexDirection: 'row',
    alignItems: 'center',
}));
